import React from "react";
import "./Body.scss";

const Body = ({ children }) => {
  return <div className="Body">{children}</div>;
};

export default Body;
